import { serviceGroupActionTypes } from './serviceGroup.types';

const INITIAL_STATE = {
    serviceGroups: [],
    serviceGroup: {},
    textConfigs: [],
    timeConfigs: [],
    openHours: []
};

const serviceGroupsReducer = (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case serviceGroupActionTypes.SET_SERVICE_GROUPS:
            return {
                ...state,
                serviceGroups: action.payload
            };
        case serviceGroupActionTypes.SET_SERVICE_GROUP:
            return {
                ...state,
                serviceGroup: action.payload
            };
        case serviceGroupActionTypes.SET_TEXT_CONFIGS:
            return {
                ...state,
                textConfigs: action.payload
            };
        case serviceGroupActionTypes.SET_TIME_CONFIGS:
            return {
                ...state,
                timeConfigs: action.payload
            };
        case serviceGroupActionTypes.SET_OPEN_HOURS:
            return {
                ...state,
                openHours: action.payload
            };
        default:
            return state;
    }
};

export default serviceGroupsReducer;